import React from 'react';
import { useSubject } from '../../context/SubjectContext';
import { useNavigate } from 'react-router-dom';
import MarkSubmissionVisitScreen from '../../components/MarkSubmission/MarkSubmissionVisitScreen';
import { Toaster } from "react-hot-toast";
import { getQualificationTitle } from '../../utils/utils';


const MarkSubmissionLandingPage = () => {
    const navigate  = useNavigate()

    const onClickBackToDashboard = () => {
        navigate("/dashboard")
    }

    const { subjectData , subjects} = useSubject();
    const { selectedSubject, selectedSubjectCode } = subjectData || {};
      const SuccessIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      {/* White circle with green border */}
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="#FFFFFF"
        stroke="#2B8000"
        strokeWidth="2"
      />
      {/* Green tick */}
      <path
        d="M8 12.5l2.5 2.5L16 9.5"
        fill="none"
        stroke="#2B8000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
    return (
        <div style={{ paddingLeft: '25px', paddingRight: '25px', paddingBottom:"50px" }}>
            <div className="xcontainer">
                <section className="section mt-0 py-0">
                    <div className="pt-5 subject-header-fixed" >
                        <p className="is-size-6 has-text-weight-bold">
                            {getQualificationTitle(subjects, subjectData?.selectedSubjectId)}
                        </p>
                        <h1 className="title is-2 mb-0">
                            {selectedSubject}{" "}
                            <span className="is-size-6 has-text-weight-normal">{selectedSubjectCode}</span>
                        </h1>
                        <p className="xbox xnotification is-info mt-0">Marks submission</p>
                        <hr className="mb-0 mt-2" />
                    </div>

                    <div className="subject-page-content xpt-2" style={{ marginTop: "1em" }}>
                        <div style={{ display: 'flex' }} className="my-2 has-text-align-right" action-bar="">
                            <button
                                style={{ letterSpacing: '0.5px' }}
                                className="button is-text is-outlined"
                                onClick={onClickBackToDashboard}
                            >
                                <span className="icon mr-2">
                                    <svg
                                        style={{ fill: "#0076BD" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="24"
                                        viewBox="0 -960 960 960"
                                        width="24"
                                        aria-hidden="true"
                                        focusable="false"
                                    >
                                        <path d="M560-253.847 333.847-480 560-706.153 602.153-664l-184 184 184 184L560-253.847Z"></path>
                                    </svg>
                                </span>
                                Back to subject dashboard
                            </button>
                        </div>

                    </div>
                </section>
            </div>
               <Toaster
            position="top-right"
            containerStyle={{ marginTop: "8rem" }}
            toastOptions={{
              style: {
                width: "350px",
                borderRadius: "4px",
                fontFamily:
                  "'Open Sans', 'Source Sans 3', Arial, Helvetica, sans-serif",
                boxShadow:
                  "rgba(0, 0, 0, 0.14) 0px 8px 12px -4px, rgba(0, 0, 0, 0.24) 0px 4px 6px -2px",
              },
              success: {
                style: {
                  backgroundColor: "#f5faf5",
                  border: "1px solid #2B8000",
                  color: "#2B8000",
                },
                // iconTheme is optional now; icon overrides it
                icon: <SuccessIcon />,
              },
            }}
          />
            <MarkSubmissionVisitScreen subjectData={subjectData} />
        </div>
    )
}

export default MarkSubmissionLandingPage;